import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccb7a052"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full flex flex-col lg:flex-row items-center gap-2" }
const _hoisted_2 = { class: "w-full lg:w-1/4" }
const _hoisted_3 = { class: "flex flex-wrap gap-2" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-wrap gap-2 items-center"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "inline-flex items-center rounded-full border border-primary30 px-3 py-2 md:px-5 md:py-3 text-xs md:text-sm text-primary30 bg-primary-50"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "inline-flex items-center rounded-full border border-primary30 px-3 py-2 md:px-5 md:py-3 text-xs md:text-sm text-primary30 bg-primary-50"
}
const _hoisted_14 = { class: "flex flex-col min-h-[300px]" }

import { ref, computed, onMounted, defineAsyncComponent, watch } from 'vue'
import { useErrorToast } from '@/composables/useErrorToast'
import { useRouter, useRoute } from 'vue-router'

import AuditoriumExceptionalitiesCard from './components/AuditoriumExceptionalitiesCard.vue'
import AuditoriumExceptionalitiesCardSkeleton from '@/components/designSystem/Skeleton/AuditoriumExceptionalitiesCardSkeleton.vue'
import SearchInput from '@/components/designSystem/Inputs/SearchInput.vue'
import EmptyList from '@/components/EmptyList.vue'
import DateFilter from '@/components/Filters/DateFilter.vue'
import SelectFilter from '@/components/Filters/SelectFilter.vue'
import ValueRangeFilter, { type ValueRange } from '@/components/Filters/ValueRangeFilter.vue'

import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { storeToRefs } from 'pinia'
import { useHealthUnitStore } from '@/pinia-store/useHealthUnitStore'
import RequestExceptionalitySidebar, {
  ApprovalStatusMap
} from '@/components/designSystem/Sidebar/RequestExceptionalitySidebar.vue'
import SummaryExceptionalitySidebar from '@/components/designSystem/Sidebar/SummaryExceptionalitySidebar.vue'
import { usePostStationLock } from '@/modules/company/PostStation/composables/usePostStationLock'
import StationDetailsModal from '../Dashboard/components/stationDetailsModal.vue'
import ExceptionService from '@/Network/Services/DoctorStationException'
import {
  StationToUpdate,
  mapCoverageToStationUpdate
} from '../Dashboard/modals/createStation/helpers'
import { withNavigatedStationId } from '@/utils/permanence'
import StationService from '@/Network/Services/StationService'
import {
  ExceptionRequest,
  ExceptionStatusEnum,
  ExceptionActionType
} from '@/Network/Types/Requests/DoctorStationExceptionRequests'
import { formatProportionalityRule } from '@/utils/formatters'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { isReversalPending } from '@/utils/exception-reversal'

interface DateRange {
  start: Date | null
  end: Date | null
}

const itemsPerPage = 5

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const { notifyError } = useErrorToast()
const permissionsStore = usePermissionsStore()
const { flags } = useFeatureFlags()

const canReadExceptionList = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationExceptionalitiesListReading,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

const textInput = ref('')
const loading = ref(false)
const list = ref<ExceptionRequest[]>([])

const openFilterName = ref<string | null>(null)
const dateFilterRef = ref<InstanceType<typeof DateFilter> | null>(null)
const valueFilterRef = ref<InstanceType<typeof ValueRangeFilter> | null>(null)
const selectedMinValue = ref<number | undefined>(undefined)
const selectedMaxValue = ref<number | undefined>(undefined)

const selectedStatusKeys = ref<string[]>([])
const selectedScheduleIds = ref<string[]>([])
const selectedHealthUnitIds = ref<string[]>([])
const selectedDateRange = ref<DateRange>({ start: null, end: null })

const approvalStatusMap = ref<ApprovalStatusMap>({
  financials: null,
  repassMode: null,
  proportionalityRule: null,
  workJourney: null
})

const selectedDateLabel = ref<string | null>(null)

const currentPage = ref(1)
const totalItems = ref(15)
const pageCount = computed(() => Math.ceil(totalItems.value / itemsPerPage))

const scheduleStore = useScheduleStore()
const { listSchedules } = storeToRefs(scheduleStore)

const healthUnitStore = useHealthUnitStore()
const { listHealthUnits } = storeToRefs(healthUnitStore)

const headerStore = useHeaderStore()

const isStationDetailsModalOpen = ref(false)
const isRequestExceptionalitySidebarOpen = ref(false)
const isSummaryExceptionalitySidebarOpen = ref(false)
const summaryActionType = ref<ExceptionActionType>(ExceptionActionType.VIEW)
const requestSidebarMode = ref<'APPROVAL' | 'REVERSAL'>('APPROVAL')

const exceptionIdSelected = ref<any | null>(null)
const stationSelected = ref<StationToUpdate | null>(null)

/**
 * Trava do Pós-Plantão (RN-07 / RF-12) do plantão do pedido aberto.
 *
 * Esta tela é o destino do deep-link do domínio `exception` do painel
 * Pós-Plantão (`originRoutes.ts`), então precisa da trava tanto quanto a tela de
 * Aprovações. As sidebars são do design system e não podem sondar
 * `Network.postStation` — quem calcula é o módulo. *
 * A MESMA instância desce para o `StationDetailsModal` (`postStationLock`), que
 * então não sonda de novo: 1 GET por clique. E só sonda plantão já encerrado
 * (`endHour` vem do `doctorStation`, então sem médico a data é inválida e a
 * sondagem não acontece) — antes disso a avaliação não existe e o GET é 404.
 */
const postStationLock = usePostStationLock(
  () => stationSelected.value?.stationId,
  () => stationSelected.value?.scheduleId,
  () => ({ endHour: stationSelected.value?.endHour })
)
const { isPostStationLocked, refresh: refreshPostStationLock } = postStationLock
const stationContextData = ref<any>(undefined)
const pendingExceptionId = ref<number | null>(null)

const scaleIcon = defineAsyncComponent(() => import('@/assets/icons/scale.vue'))
const statusIcon = defineAsyncComponent(() => import('@/assets/icons/status.vue'))
const hospitalIcon = defineAsyncComponent(() => import('@/assets/icons/hospital.vue'))
const moneyIcon = defineAsyncComponent(() => import('@/assets/icons/money.vue'))

const handleStatusMapChange = (statusMap: ApprovalStatusMap) => {
  approvalStatusMap.value = statusMap
}

// Navegação real da linha de vínculo de Registro de Permanência: só troca o
// `stationId` da seleção já existente — o `StationDetailsModal` (mantido
// aberto) refaz o fetch sozinho via watch interno de `props.infos.stationId`.
function handleNavigateToStation(stationId: number) {
  stationSelected.value = withNavigatedStationId(stationSelected.value, stationId)
}

const scheduleOptions = computed(() =>
  listSchedules.value.map((item) => ({
    label: item.title,
    value: String(item.value)
  }))
)

const healthUnitOptions = computed(() =>
  listHealthUnits.value.map((unit) => ({
    label: unit.title,
    value: String(unit.value)
  }))
)

const statusOptions = [
  { label: 'Em andamento', value: 'in_progress' },
  { label: 'Aprovado', value: 'approved' },
  { label: 'Recusado', value: 'rejected' },
  { label: 'Revertido', value: 'reverted' },
  { label: 'Cancelado', value: 'cancelled' }
]

const statusKeyToEnumValue: { [key: string]: ExceptionStatusEnum } = {
  in_progress: ExceptionStatusEnum.AWAITING_APPROVAL,
  approved: ExceptionStatusEnum.APPROVED,
  rejected: ExceptionStatusEnum.REJECTED,
  reverted: ExceptionStatusEnum.REVERTED,
  cancelled: ExceptionStatusEnum.CANCELED
}

const selectedStatusObjects = computed(() =>
  selectedStatusKeys.value
    .map((key) => statusOptions.find((opt) => opt.value === key))
    .filter((s): s is { label: string; value: string } => !!s)
)
const selectedScheduleObjects = computed(() =>
  selectedScheduleIds.value
    .map((id) => scheduleOptions.value.find((opt) => opt.value === id))
    .filter((s): s is { label: string; value: string } => !!s)
)
const selectedHealthUnitObjects = computed(() =>
  selectedHealthUnitIds.value
    .map((id) => healthUnitOptions.value.find((opt) => opt.value === id))
    .filter((u): u is { label: string; value: string } => !!u)
)

const valueFilterLabel = computed(() => {
  const parts: string[] = []
  if (selectedMinValue.value !== undefined) parts.push(`mín R$${selectedMinValue.value}`)
  if (selectedMaxValue.value !== undefined) parts.push(`máx R$${selectedMaxValue.value}`)
  return parts.join(' – ')
})

const hasActiveFilters = computed(() => {
  const hasSearch = textInput.value !== ''
  const hasSchedules = selectedScheduleIds.value.length > 0
  const hasUnits = selectedHealthUnitIds.value.length > 0
  const hasDate = selectedDateRange.value.start !== null || selectedDateRange.value.end !== null
  const hasStatus = selectedStatusKeys.value.length > 0
  const hasValue = selectedMinValue.value !== undefined || selectedMaxValue.value !== undefined
  return hasSearch || hasSchedules || hasUnits || hasDate || hasStatus || hasValue
})

function handleValueFilter(payload: ValueRange) {
  selectedMinValue.value = payload.min
  selectedMaxValue.value = payload.max
  openFilterName.value = null
  currentPage.value = 1
  fetchData()
}

function clearValue() {
  selectedMinValue.value = undefined
  selectedMaxValue.value = undefined
  valueFilterRef.value?.reset()
  fetchData()
}

function clearAllFilters() {
  textInput.value = ''
  selectedScheduleIds.value = []
  selectedHealthUnitIds.value = []
  selectedDateRange.value = { start: null, end: null }
  selectedDateLabel.value = null
  selectedMinValue.value = undefined
  selectedMaxValue.value = undefined
  valueFilterRef.value?.reset()
  currentPage.value = 1
  selectedStatusKeys.value = ['in_progress']
  closeAllFilters()
  fetchData()
}

function toggleFilter(name: string) {
  if (name !== 'date') {
    dateFilterRef.value?.close?.()
  }
  openFilterName.value = openFilterName.value === name ? null : name
}

function closeAllFilters() {
  openFilterName.value = null
  dateFilterRef.value?.close()
}

const changePage = (page: number) => {
  currentPage.value = page
  fetchData()
}

const updateUrlWithFilters = () => {
  const query: any = {}
  if (selectedStatusKeys.value.length) query.status = selectedStatusKeys.value.join(',')
  if (selectedScheduleIds.value.length) query.scheduleIds = selectedScheduleIds.value.join(',')
  if (selectedHealthUnitIds.value.length)
    query.healthUnitIds = selectedHealthUnitIds.value.join(',')
  if (selectedDateRange.value.start)
    query.startDate = selectedDateRange.value.start.toISOString().split('T')[0]
  if (selectedDateRange.value.end)
    query.endDate = selectedDateRange.value.end.toISOString().split('T')[0]
  if (textInput.value) query.search = textInput.value
  if (currentPage.value > 1) query.page = String(currentPage.value)

  router.push({ query })
}

const setFiltersFromUrl = () => {
  const query = route.query
  selectedStatusKeys.value = query.status ? String(query.status).split(',') : ['in_progress']
  selectedScheduleIds.value = query.scheduleIds ? String(query.scheduleIds).split(',') : []
  selectedHealthUnitIds.value = query.healthUnitIds ? String(query.healthUnitIds).split(',') : []
  textInput.value = query.search ? String(query.search) : ''
  currentPage.value = query.page ? Number(query.page) : 1

  if (query.startDate) {
    selectedDateRange.value.start = parseISO(String(query.startDate))
  }
  if (query.endDate) {
    selectedDateRange.value.end = parseISO(String(query.endDate))
  }

  if (query.exceptionId) {
    pendingExceptionId.value = Number(query.exceptionId)
    selectedStatusKeys.value = []
  }

  handleDateFilter(selectedDateRange.value, false)
}

const buildFilterParams = (): Record<string, any> => {
  const params: Record<string, any> = {}

  if (selectedStatusKeys.value.length) {
    const backendStatuses = selectedStatusKeys.value.map((key) => statusKeyToEnumValue[key])
    params.status = backendStatuses.join(',')
  }

  if (selectedScheduleIds.value.length) params.scheduleIds = selectedScheduleIds.value.join(',')
  if (selectedHealthUnitIds.value.length)
    params.healthUnitIds = selectedHealthUnitIds.value.join(',')
  if (selectedDateRange.value.start) params.startDate = selectedDateRange.value.start.toISOString()
  if (selectedDateRange.value.end) params.endDate = selectedDateRange.value.end.toISOString()
  if (textInput.value) params.search = textInput.value
  if (selectedMinValue.value !== undefined) params.minValue = selectedMinValue.value
  if (selectedMaxValue.value !== undefined) params.maxValue = selectedMaxValue.value

  return params
}

const fetchData = async () => {
  loading.value = true
  const service = new ExceptionService()

  const offset = (currentPage.value - 1) * itemsPerPage
  const params = { limit: itemsPerPage, offset, ...buildFilterParams() }

  updateUrlWithFilters()

  try {
    const response = await service.list(params)
    list.value = response?.data || []
    totalItems.value = response?.count || 0
  } catch (error) {
    console.error('Erro ao listar pedidos de excepcionalidade', error)
    // Antes: swallow — a falha de load parecia "nenhum pedido".
    notifyError(error, 'Não foi possível carregar os pedidos de excepcionalidade')
    list.value = []
  } finally {
    loading.value = false
  }
}

const onSearchByTabIndex = () => {
  currentPage.value = 1
  fetchData()
}

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
const handleDetails = async (item: ExceptionRequest) => {
  approvalStatusMap.value = {
    financials: null,
    repassMode: null,
    proportionalityRule: null,
    workJourney: null
  }

  const service = new StationService()
  try {
    const data = await service.getStationDetails(item.doctorStation.station.id)
    if (!data) return

    const stationForModal: StationToUpdate = {
      stationId: data.id,
      companyId: data.schedule?.healthUnit?.company?.id ?? 0,
      doctorStationId: data.id,
      date: new Date(data.date),
      startHour: new Date(data?.doctorStation?.startHour),
      endHour: new Date(data?.doctorStation?.endHour),
      timezone: data?.doctorStation?.timezone ?? '-03:00',
      stationType: data?.doctorStation?.type ?? 'N/A',
      ourTeam: data.doctorStation.ourTeam ?? false,
      value: data.value ?? 0,
      stationValue: data.doctorStation.value ?? 0,
      inCash: data.inCash ?? false,
      advanceRequested: data.doctorStation.requestAntecipe ?? false,
      advancePaid: data.doctorStation.antecipeWasPaid ?? false,
      modifiedValue: data.doctorStation.modifiedValue ?? false,
      position: data.position,
      checks: [],
      observations: data.doctorStation.observations ?? [],
      healthUnitLatitude: '',
      healthUnitLongitude: '',
      doctorId: undefined,
      doctorPending: undefined,
      urlConviteDoctor: undefined,
      userSponsor: data?.doctorStation.userSponsor,
      scheduleId: data?.schedule?.id,
      // E-06: estado da cobertura (vazio com BE antigo).
      ...mapCoverageToStationUpdate(data)
    }
    const formatStationDate = (dateStr?: string) => {
      if (!dateStr) return null
      try {
        const d = new Date(dateStr)
        if (isNaN(d.getTime())) return null
        const weekday = d.toLocaleDateString('pt-BR', { weekday: 'long' })
        const date = d.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        })
        const time = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
        return { weekday, date, time }
      } catch {
        return null
      }
    }

    const startTime = formatStationDate(data.doctorStation?.startHour)
    const endTime = formatStationDate(data.doctorStation?.endHour)
    const doctor = item.doctor
    const sponsor = data.doctorStation?.userSponsor

    stationContextData.value = {
      doctorName: doctor?.name || '',
      doctorCrm: doctor?.crm ? `${doctor.crm.number}-${doctor.crm.uf}` : undefined,
      scheduleName: data.schedule?.name || '',
      positionName: data.position?.name || '',
      shiftName: data.shift?.name || '',
      team: data.doctorStation?.ourTeam ? 'Interno' : 'Externo',
      timeRange:
        startTime && endTime
          ? `${startTime.date} ${startTime.time} - ${endTime.date} ${endTime.time}`
          : '',
      dutyType: data.doctorStation?.type || '',
      value: data.value != null ? `R$ ${Number(data.value).toLocaleString('pt-BR')}` : undefined,
      formation: data.doctorStation?.dsPaymentDoctorFormation?.name || '',
      repassMode:
        data.doctorStation?.inCash != null
          ? data.doctorStation.inCash
            ? 'À vista'
            : 'Fluxo'
          : undefined,
      proportionalityRule: formatProportionalityRule(data.schedule?.proportionalityRule || null),
      breadcrumb: [
        data.schedule?.healthUnit?.company?.name,
        data.schedule?.healthUnit?.name,
        data.schedule?.name,
        data.position?.name
      ]
        .filter(Boolean)
        .join(' > '),
      allocatedBy: sponsor?.name || undefined,
      startDetail: startTime
        ? `${startTime.weekday}, ${startTime.date} às ${startTime.time}`
        : undefined,
      endDetail: endTime ? `${endTime.weekday}, ${endTime.date} às ${endTime.time}` : undefined,
      timezone: data.doctorStation?.timezone || undefined
    }

    stationSelected.value = stationForModal
    exceptionIdSelected.value = item.exceptionId
    isStationDetailsModalOpen.value = true

    // Reversão multi-etapa aguardando votos vem antes do roteamento por status:
    // o status continua "Aprovado" enquanto a reversão está pendente.
    if (isReversalPending(item, flags.enabledApprovalEngine)) {
      isSummaryExceptionalitySidebarOpen.value = false
      requestSidebarMode.value = 'REVERSAL'
      isRequestExceptionalitySidebarOpen.value = true
    } else if (item.status === ExceptionStatusEnum.AWAITING_APPROVAL) {
      requestSidebarMode.value = 'APPROVAL'
      isSummaryExceptionalitySidebarOpen.value = false
      isRequestExceptionalitySidebarOpen.value = true
    } else {
      isRequestExceptionalitySidebarOpen.value = false
      if (item.status === ExceptionStatusEnum.APPROVED) {
        summaryActionType.value = ExceptionActionType.REVERT
      } else {
        summaryActionType.value = ExceptionActionType.VIEW
      }
      isSummaryExceptionalitySidebarOpen.value = true
    }

    // Depois de `stationSelected` de propósito: o gate de leitura da trava é
    // escopado na `scheduleId`, que só existe a partir do detalhe do plantão.
    await refreshPostStationLock()
  } catch (error) {
    console.error('Erro ao buscar detalhes da estação', error)
    // Antes: swallow — o clique no card não abria nada e não dizia por quê.
    notifyError(error, 'Não foi possível carregar os detalhes do plantão')
  }
}

function handleStatusSelect(value: string) {
  const currentKeys = [...selectedStatusKeys.value]
  const index = currentKeys.indexOf(value)

  if (index > -1) {
    currentKeys.splice(index, 1)
  } else {
    currentKeys.push(value)
  }
  selectedStatusKeys.value = currentKeys

  currentPage.value = 1
  fetchData()
}

function handleScheduleSelect(value: string) {
  const currentIds = [...selectedScheduleIds.value]
  const index = currentIds.indexOf(value)

  if (index > -1) {
    currentIds.splice(index, 1)
  } else {
    currentIds.push(value)
  }
  selectedScheduleIds.value = currentIds

  currentPage.value = 1
  fetchData()
}

function handleHealthUnitSelect(value: string) {
  const currentIds = [...selectedHealthUnitIds.value]
  const index = currentIds.indexOf(value)

  if (index > -1) {
    currentIds.splice(index, 1)
  } else {
    currentIds.push(value)
  }
  selectedHealthUnitIds.value = currentIds

  currentPage.value = 1
  fetchData()
}

function handleDateFilter(payload: DateRange, shouldFetch = true) {
  selectedDateRange.value = payload
  if (payload.start && payload.end) {
    const formattedStart = format(payload.start, 'dd/MM/yyyy', { locale: ptBR })
    const formattedEnd = format(payload.end, 'dd/MM/yyyy', { locale: ptBR })
    if (formattedStart === formattedEnd) {
      selectedDateLabel.value = formattedStart
    } else {
      selectedDateLabel.value = `${formattedStart} - ${formattedEnd}`
    }
  } else {
    selectedDateLabel.value = null
  }

  if (shouldFetch) {
    currentPage.value = 1
    fetchData()
  }
}

function removeStatus(value: string) {
  const index = selectedStatusKeys.value.indexOf(value)
  if (index > -1) {
    selectedStatusKeys.value.splice(index, 1)
    fetchData()
  }
}
function removeSchedule(value: string) {
  const index = selectedScheduleIds.value.indexOf(value)
  if (index > -1) {
    selectedScheduleIds.value.splice(index, 1)
    fetchData()
  }
}
function removeHealthUnit(value: string) {
  const index = selectedHealthUnitIds.value.indexOf(value)
  if (index > -1) {
    selectedHealthUnitIds.value.splice(index, 1)
    fetchData()
  }
}

function clearDate() {
  selectedDateRange.value = { start: null, end: null }
  selectedDateLabel.value = null
  fetchData()
}

watch(isStationDetailsModalOpen, (newValue) => {
  if (!newValue) {
    isRequestExceptionalitySidebarOpen.value = false
    isSummaryExceptionalitySidebarOpen.value = false
  }
})

watch(isRequestExceptionalitySidebarOpen, (newValue) => {
  if (!newValue) {
    isStationDetailsModalOpen.value = false
  }
})

watch(isSummaryExceptionalitySidebarOpen, (newValue) => {
  if (!newValue) {
    isStationDetailsModalOpen.value = false
  }
})

watch(loading, (isLoading) => {
  if (!isLoading && pendingExceptionId.value) {
    const targetId = pendingExceptionId.value
    pendingExceptionId.value = null
    const item = list.value.find((i) => i.exceptionId === targetId)
    if (item) {
      handleDetails(item)
    }
  }
})

onMounted(async () => {
  headerStore.setTitle(
    'Pedidos de Excepcionalidade',
    'Analise, aprove ou recuse solicitações excepcionais vinculadas a escalas e plantões',
    { label: 'Aprovações', route: '/aprovacoes' }
  )

  await Promise.all([
    scheduleStore.getAllSchedules(),
    healthUnitStore.fetchAllHealthUnitsForSelect()
  ])
  setFiltersFromUrl()
  fetchData()
})

return (_ctx: any,_cache: any) => {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "flex flex-col gap-y-6 relative",
      onClick: closeAllFilters
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SearchInput, {
            modelValue: textInput.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textInput).value = $event)),
            onInput: onSearchByTabIndex,
            width: "100%",
            loading: loading.value,
            label: "Buscar",
            "hide-details": "",
            density: "compact"
          }, null, 8, ["modelValue", "loading"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (toggleFilter('status')), ["stop"]))
            }, [
              _createVNode(SelectFilter, {
                label: "Status",
                icon: _unref(statusIcon),
                options: statusOptions,
                "dropdown-width": "w-40",
                onSelect: handleStatusSelect,
                "is-open": openFilterName.value === 'status',
                multiple: "",
                selectedValue: selectedStatusKeys.value
              }, null, 8, ["icon", "is-open", "selectedValue"])
            ])
          ]),
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (toggleFilter('date')), ["stop"]))
          }, [
            _createVNode(DateFilter, {
              ref_key: "dateFilterRef",
              ref: dateFilterRef,
              "is-open": openFilterName.value === 'date',
              onSelect: handleDateFilter
            }, null, 8, ["is-open"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (toggleFilter('schedule')), ["stop"]))
            }, [
              _createVNode(SelectFilter, {
                label: "Escala",
                icon: _unref(scaleIcon),
                options: scheduleOptions.value,
                searchable: "",
                "dropdown-width": "w-64",
                onSelect: handleScheduleSelect,
                "is-open": openFilterName.value === 'schedule',
                multiple: "",
                selectedValue: selectedScheduleIds.value
              }, null, 8, ["icon", "options", "is-open", "selectedValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (toggleFilter('unit')), ["stop"]))
            }, [
              _createVNode(SelectFilter, {
                label: "Unidades",
                icon: _unref(hospitalIcon),
                options: healthUnitOptions.value,
                searchable: "",
                "dropdown-width": "w-64",
                onSelect: handleHealthUnitSelect,
                "is-open": openFilterName.value === 'unit',
                multiple: "",
                selectedValue: selectedHealthUnitIds.value
              }, null, 8, ["icon", "options", "is-open", "selectedValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (toggleFilter('value')), ["stop"]))
            }, [
              _createVNode(ValueRangeFilter, {
                ref_key: "valueFilterRef",
                ref: valueFilterRef,
                label: "Valor",
                icon: _unref(moneyIcon),
                "is-open": openFilterName.value === 'value',
                onSelect: handleValueFilter
              }, null, 8, ["icon", "is-open"])
            ])
          ])
        ])
      ]),
      (hasActiveFilters.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedStatusObjects.value, (status) => {
              return (_openBlock(), _createElementBlock("span", {
                key: status.value,
                class: "inline-flex items-center rounded-full border border-primary30 px-3 py-2 md:px-5 md:py-3 text-xs md:text-sm text-primary30 bg-primary-50"
              }, [
                _createTextVNode(_toDisplayString(status.label) + " ", 1),
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeStatus(status.value)),
                  class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none"
                }, " × ", 8, _hoisted_9)
              ]))
            }), 128)),
            (selectedDateLabel.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createTextVNode(_toDisplayString(selectedDateLabel.value) + " ", 1),
                  _createElementVNode("button", {
                    onClick: clearDate,
                    class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none"
                  }, " × ")
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedScheduleObjects.value, (schedule) => {
              return (_openBlock(), _createElementBlock("span", {
                key: schedule.value,
                class: "inline-flex items-center rounded-full border border-primary30 px-3 py-2 md:px-5 md:py-3 text-xs md:text-sm text-primary30 bg-primary-50"
              }, [
                _createTextVNode(_toDisplayString(schedule.label) + " ", 1),
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeSchedule(schedule.value)),
                  class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none"
                }, " × ", 8, _hoisted_11)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedHealthUnitObjects.value, (unit) => {
              return (_openBlock(), _createElementBlock("span", {
                key: unit.value,
                class: "inline-flex items-center rounded-full border border-primary30 px-3 py-2 md:px-5 md:py-3 text-xs md:text-sm text-primary30 bg-primary-50"
              }, [
                _createTextVNode(_toDisplayString(unit.label) + " ", 1),
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeHealthUnit(unit.value)),
                  class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none"
                }, " × ", 8, _hoisted_12)
              ]))
            }), 128)),
            (selectedMinValue.value !== undefined || selectedMaxValue.value !== undefined)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createTextVNode(" Valor: " + _toDisplayString(valueFilterLabel.value) + " ", 1),
                  _createElementVNode("button", {
                    onClick: clearValue,
                    class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none"
                  }, " × ")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", { class: "ml-2 flex" }, [
              _createElementVNode("button", {
                onClick: clearAllFilters,
                class: "text-sm font-bold text-primary hover:text-primary-darken-1 transition-colors"
              }, " Limpar filtros ")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        (loading.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(itemsPerPage, (n) => {
              return _createVNode(AuditoriumExceptionalitiesCardSkeleton, {
                key: `skeleton-${n}`
              })
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (list.value?.length && canReadExceptionList.value)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(list.value, (item, i) => {
                    return (_openBlock(), _createBlock(AuditoriumExceptionalitiesCard, {
                      key: i,
                      exceptionId: item.exceptionId,
                      date: item?.doctorStation?.date,
                      doctor: item.doctor || { crm: {}, document: {} },
                      scale: item?.doctorStation?.station?.schedule?.name,
                      unit: item?.doctorStation?.station?.schedule?.healthUnit?.name,
                      prejudice: item.financials.estimatedLossTotal,
                      status: item.status,
                      onDetails: () => handleDetails(item)
                    }, null, 8, ["exceptionId", "date", "doctor", "scale", "unit", "prejudice", "status", "onDetails"]))
                  }), 128))
                : (_openBlock(), _createBlock(EmptyList, {
                    key: 1,
                    title: "Nenhum pedido encontrado"
                  }))
            ], 64))
      ]),
      (!loading.value && list.value.length > 0)
        ? (_openBlock(), _createBlock(_component_v_pagination, {
            key: 1,
            modelValue: currentPage.value,
            "onUpdate:modelValue": [
              _cache[6] || (_cache[6] = ($event: any) => ((currentPage).value = $event)),
              changePage
            ],
            "total-visible": 3,
            length: pageCount.value,
            density: "comfortable",
            color: "primary"
          }, null, 8, ["modelValue", "length"]))
        : _createCommentVNode("", true)
    ]),
    (stationSelected.value)
      ? (_openBlock(), _createBlock(StationDetailsModal, {
          key: 0,
          infos: stationSelected.value,
          "show-modal": isStationDetailsModalOpen.value,
          "onUpdate:showModal": _cache[7] || (_cache[7] = ($event: any) => (isStationDetailsModalOpen.value = $event)),
          onCloseModal: _cache[8] || (_cache[8] = ($event: any) => (isStationDetailsModalOpen.value = false)),
          onEditStation: () => {},
          onNavigateToStation: handleNavigateToStation,
          mode: 'approvals',
          "is-pushed-externally": isRequestExceptionalitySidebarOpen.value || isSummaryExceptionalitySidebarOpen.value,
          exceptionIdSelected: exceptionIdSelected.value,
          "approval-status-map": approvalStatusMap.value,
          "post-station-lock": _unref(postStationLock)
        }, null, 8, ["infos", "show-modal", "is-pushed-externally", "exceptionIdSelected", "approval-status-map", "post-station-lock"]))
      : _createCommentVNode("", true),
    (exceptionIdSelected.value)
      ? (_openBlock(), _createBlock(RequestExceptionalitySidebar, {
          key: 1,
          "is-open": isRequestExceptionalitySidebarOpen.value,
          "onUpdate:isOpen": _cache[9] || (_cache[9] = ($event: any) => ((isRequestExceptionalitySidebarOpen).value = $event)),
          "exception-id": exceptionIdSelected.value,
          scheduleId: stationSelected.value?.scheduleId || 1,
          "station-context": stationContextData.value,
          "post-station-locked": _unref(isPostStationLocked),
          mode: requestSidebarMode.value,
          onSubmitSuccess: fetchData,
          onStatusMapChanged: handleStatusMapChange
        }, null, 8, ["is-open", "exception-id", "scheduleId", "station-context", "post-station-locked", "mode"]))
      : _createCommentVNode("", true),
    (exceptionIdSelected.value)
      ? (_openBlock(), _createBlock(SummaryExceptionalitySidebar, {
          key: 2,
          "is-open": isSummaryExceptionalitySidebarOpen.value,
          "exception-id": exceptionIdSelected.value,
          "action-type": summaryActionType.value,
          scheduleId: stationSelected.value?.scheduleId || 1,
          "post-station-locked": _unref(isPostStationLocked),
          "onUpdate:isOpen": _cache[10] || (_cache[10] = ($event: any) => (isSummaryExceptionalitySidebarOpen.value = $event)),
          onActionCompleted: fetchData
        }, null, 8, ["is-open", "exception-id", "action-type", "scheduleId", "post-station-locked"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})